import { render, staticRenderFns } from "./Arhiva.vue?vue&type=template&id=0557a148&scoped=true&"
import script from "./Arhiva.vue?vue&type=script&lang=js&"
export * from "./Arhiva.vue?vue&type=script&lang=js&"
import style0 from "./Arhiva.vue?vue&type=style&index=0&id=0557a148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0557a148",
  null
  
)

export default component.exports